// HomePage.js
import Gif from "./Gif";
import Projects from "./Projects";
import Writing from "./Writing";
import Sidebar from "./Sidebar";
const HomePage = () => (
    <div>
      <Sidebar />
      <Projects/>
      <Writing/>
      <Gif />
    </div>
  );
  
  export default HomePage;
  